import React, { useState } from "react";
import { useSelector } from "react-redux";
import Moment from "moment";
import { makeStyles, Grid } from "@material-ui/core";
import { Select, Typography, Page } from "@packages/ui";
import DownloadButtonGrid from "src/layouts/DashboardLayout/DownloadButtonGrid";
import { useCurrentRental } from "src/hooks/rentalHooks";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 15,
    paddingBottom: theme.spacing(3),
  },
}));

const InfringementsInvoice = () => {
  const classes = useStyles();
  const rentals = useSelector((state) => ({ ...state.app.rentals }));
  const currentRental = useCurrentRental();
  const [raNumber, setRaNumber] = useState(currentRental.rental_agreement_number);
  const pickUpDate = currentRental.pickup ? currentRental.pickup.dateTime : "No Date Data";
  const fileName = "infringements";

  function handleSelectClick(e) {
    setRaNumber(e.target.value);
  }

  return (
    <Page className={classes.root} title="Infringements Invoice - My Journey Portal">
      <Grid container>
        <Grid item xs={12}>
          <Typography variant={"h1"} style={{ marginBottom: 30 }}>
            Infringements Invoice
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ marginBottom: 30 }}>
            Your infringements invoice is available. Select from one of the options below.
          </Typography>
        </Grid>
        <Grid container spacing={1}>
          <Grid item>
            <Select
              title={`${raNumber} - ${Moment(pickUpDate, "YYYY-MM-DD hh:mm").format("DD/MM/YYYY")}`}
              value={raNumber}
              onChange={(e) => handleSelectClick(e)}
              options={Object.keys(rentals).map((key) =>
                rentals[key].infringements
                  ? {
                      value: rentals[key].rental_agreement_number,
                      title: rentals[key].pickup
                        ? `${rentals[key].rental_agreement_number} - ${Moment(
                            rentals[key].pickup.dateTime,
                            "YYYY-MM-DD hh:mm"
                          ).format("DD/MM/YYYY")}`
                        : `${rentals[key].rental_agreement_number} - No Pickup Data`,
                    }
                  : {
                      value: 0,
                      title: `${rentals[key].rental_agreement_number} - No Infringements Invoice`,
                    }
              )}
            ></Select>
          </Grid>
          <DownloadButtonGrid raNumber={raNumber} fileName={fileName} fileLabel="Infringements Invoice" />
        </Grid>
      </Grid>
    </Page>
  );
};

export default InfringementsInvoice;
